import React, { Component } from "react";
import FullPageLoader from "../Loader/FullPageLoader";
import Loader from "../Loader/Loader";
import axios from "axios";
import Header from "../Header/Header";
import ReactPaginate from "react-paginate";
class Binary extends Component {
  constructor(props) {
    super(props);
    var accessToken = localStorage.getItem("token");
    this.state = {
      accessToken: accessToken,
      CasinoDetail: [],
      isLoding: false,
      offset: 0,
      data: [],
      tabledata:[],
      perPage: 10,
      currentPage: 0,
      isLoding: false,
    };
  }
  componentDidMount() {
    this.callCasinoTable();
  }

  callCasinoTable = () => {
    this.setState({ isLoding: true });
    let headers = {
      Authorization: "Bearer " + this.state.accessToken,
    };
    axios.get("http://api.encabook999.com/casinotransactions", { headers }).then((resp) => {
      if (resp.data) {
        this.setState({tabledata:resp.data},()=>this.receivedData());
      } else {
        this.setState({ isLoding: false });
      }
    });
  };

  receivedData() {
    const data = this.state.tabledata;
    const slice = data.slice(
      this.state.offset,
      this.state.offset + this.state.perPage
    );
    this.setState({
      pageCount: Math.ceil(data.length / this.state.perPage),
      isLoding: false,
      CasinoDetail: slice
    });
  }
  handlePageClick = (e) => {
    const selectedPage = e.selected;
    const offset = selectedPage * this.state.perPage;
    this.setState(
      {
        currentPage: selectedPage,
        offset: offset,
      },
      () => {

        this.receivedData();
      }
    );
  };
  render() {
    const { CasinoDetail, isLoding } = this.state;
    return (
      <div className="w-100">
        <Header />
        <div id="wrapper">
          {this.state.isLoading ? <FullPageLoader /> : null}

          <div className="container-fluid">
            <h5 className="text-dark mt-5">
              <i className="fas fa-th-list mr-3" />
              Casino list
            </h5>

            <div className="table-responsive">
              <table className="table table-bordered table-striped mt-3">
                <thead>
                  <tr>
                    <th scope="col">
                      {" "}
                      <span>User Name</span>
                    </th>
                    <th scope="col">
                      {" "}
                      <span>Amount</span>
                    </th>
                    <th scope="col">
                      <span>Game Id</span>
                    </th>
                    <th scope="col">
                      <span>Game Name</span>
                    </th>
                    <th scope="col">
                      {" "}
                      <span>Balance</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {!isLoding ? (
                    CasinoDetail && CasinoDetail.length ? (
                      CasinoDetail.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              <h6>{item.user ? item.user : null}</h6>
                            </td>
                            <td>
                              <div>
                                {item.amount && item.amount
                                  ? item.amount
                                  : null}
                              </div>
                            </td>
                            <td>
                              <div>
                                {item.game_id && item.game_id
                                  ? item.game_id
                                  : null}
                              </div>
                            </td>
                            <td>
                              <div>{item.game_code ? item.game_code : "-"}</div>
                            </td>
                            <td>
                              <div>
                                {item.balance && item.balance
                                  ? item.balance
                                  : null}
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="8">
                          <h4 className="text-center">Not Found</h4>
                        </td>
                      </tr>
                    )
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center">
                        <Loader />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <div className="d-flex justify-content-end">
                <ReactPaginate
                  previousLabel={"prev"}
                  nextLabel={"next"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={this.state.pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={this.handlePageClick}
                  containerClassName={"pagination"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Binary;



// WEBPACK FOOTER //
// ./src/components/Admin/casino_report.js